class Front {
	constructor($templateCache) {
		this.restrict = 'E';
		this.scope = {
			mode: '@',
			object: '=',
			styles: '=?'
		};
		this.transclude = true;
		this.link = this.FrontLink;

		this.$templateCache = $templateCache;
		const template = this.$templateCache.get('flip-card/front/front.html');
		this.template = template;
	}

	FrontLink(scope, element, attrs) {
		const $element = angular.element(element);
	}
}

export default /* @ngInject */ ($templateCache) => new Front($templateCache);
